import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="30484" id="ready-to-launch-your-watch-brand" className="relative w-full py-24 md:py-32 overflow-hidden border-y border-[#F5F3EE]/10 bg-[#1F1F1F]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-[#F26A21]/10 to-[#1F1F1F]/40 backdrop-blur-3xl" />
        {}
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="font-sans font-bold text-4xl md:text-5xl lg:text-6xl text-[#F5F3EE] mb-8 tracking-tight drop-shadow-sm">
          Have an Idea? Let’s Turn It Into a Watch
        </h2>
        
        <p className="text-lg md:text-xl text-[#F5F3EE]/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          You don’t need a full design — just an idea is enough.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="h-14 px-8 text-lg font-semibold rounded-lg bg-[#F26A21] text-white hover:bg-[#F26A21]/90 shadow-[0_0_30px_-5px_#F26A21] hover:shadow-[0_0_50px_-5px_#F26A21] transition-all duration-300 border-none">
            <Link to="/ContactPage">
              Get a Quote
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg font-semibold rounded-lg border-[#F5F3EE]/20 bg-transparent text-[#F5F3EE] hover:bg-[#F5F3EE]/10 hover:text-[#F5F3EE] hover:border-[#F5F3EE]/40 transition-all duration-300">
            <Link to="/HowItWorksPage">
              Chat with Us
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}